import { __read, __awaiter, __generator, __assign } from 'tslib';
import React__default, { useState } from 'react';
import { useAnalyticsQueue } from '@invitae/analytics-queue';

var UserAuthContext = React__default.createContext({
    isUserAuthenticated: false,
});
var setCartAuthentication = function (_a) {
    var _b = _a.email, email = _b === void 0 ? '' : _b;
    window.user = { email: email, isAuthenticated: true };
};
var removeCartAuthentication = function () {
    delete window.user;
};
var CurrentUserContext = React__default.createContext(null);
var UserAuthProvider = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, nucleobaseConfig = _a.nucleobaseConfig;
    var _f = __read(useState(null), 2), user = _f[0], setUser = _f[1];
    var defaultAuthApiHostEndpoint = '/apigw/marcom/user/';
    var isDev = (_c = (_b = nucleobaseConfig === null || nucleobaseConfig === void 0 ? void 0 : nucleobaseConfig.context) === null || _b === void 0 ? void 0 : _b.authAPI) === null || _c === void 0 ? void 0 : _c.includes('dev.locusdev');
    var userEndpointUrl = isDev
        ? (_d = nucleobaseConfig === null || nucleobaseConfig === void 0 ? void 0 : nucleobaseConfig.context.authAPI) !== null && _d !== void 0 ? _d : defaultAuthApiHostEndpoint
        : defaultAuthApiHostEndpoint;
    var setUserProperties = useAnalyticsQueue().setUserProperties;
    var clearUserProperties = React__default.useCallback(function () {
        setUserProperties({});
    }, [setUserProperties]);
    var loadUser = React__default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(userEndpointUrl)];
                case 1: return [4 /*yield*/, (_a.sent()).json()
                    // userId will be present only if user is authenticated
                ];
                case 2:
                    response = _a.sent();
                    // userId will be present only if user is authenticated
                    if (response.id) {
                        setUser(response);
                        setUserProperties({
                            id: response.id.toString(),
                            role: response.role,
                        });
                        setCartAuthentication(response);
                    }
                    else {
                        setUser(null);
                        clearUserProperties();
                        removeCartAuthentication();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a.sent();
                    setUser(null);
                    clearUserProperties();
                    removeCartAuthentication();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [(_e = nucleobaseConfig === null || nucleobaseConfig === void 0 ? void 0 : nucleobaseConfig.context) === null || _e === void 0 ? void 0 : _e.authAPI, clearUserProperties, setUserProperties]);
    React__default.useEffect(function () {
        if (!user) {
            loadUser();
        }
    }, []);
    return React__default.createElement(UserAuthContext.Provider, { value: __assign({ isUserAuthenticated: !!user }, user) }, children);
};

export { CurrentUserContext, UserAuthContext, UserAuthProvider as default };
//# sourceMappingURL=UserAuthProvider.esm.js.map
